import React, { createContext, useReducer, useEffect, useContext } from 'react';
import { node, string } from 'prop-types';
import _ from 'lodash'; // eslint-disable-line

import {
  extend,
  params,
  string as stringType,
  shape as shapeType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { RentalEstimateWrapperProvider } from '@thd-olt-component-react/rental-estimate';

import { deliveryReducer } from '../reducers/deliveryReducer';

export const defaultContext = {
  activeSection: 'DaysAndTimes',
  deliveryDatesTimes: {
    deliveryDate: '',
    deliveryTime: '',
    pickupDate: '',
    pickupTime: '',
    deliveryDateTimeFormat: '',
    isFormEnabled: false
  },
  deliveryAddress: {
    street: '',
    city: '',
    state: '',
    zipCode: '',
    suiteNumber: ''
  },
  contractTerms: null,
  statementsOfUnderstanding: null,
  damageProtection: true
};

export const DeliveryContext = createContext(defaultContext);

const DeliveryProvider = ({
  itemId,
  children
}) => {

  const { data: productData } = useDataModel('product', { variables: { itemId } });
  const { canonicalUrl, rentalCategory, rentalSubCategory } = productData?.product?.identifiers || '';

  const [state, dispatch] = useReducer(deliveryReducer, { ...defaultContext });

  useEffect(() => {
    if (canonicalUrl && rentalCategory && rentalSubCategory) {
      dispatch({ type: 'SET_ITEM_DETAILS', payload: { canonicalUrl, rentalCategory, rentalSubCategory } });
    }
  }
  , [rentalCategory, rentalSubCategory, canonicalUrl]);

  return (
    <DeliveryContext.Provider value={[state, dispatch]}>
      {children}
    </DeliveryContext.Provider>
  );
};

DeliveryProvider.propTypes = {
  itemId: string.isRequired,
  children: node.isRequired
};

DeliveryProvider.dataModel = extend(
  RentalEstimateWrapperProvider,
  {
    product: params({ itemId: stringType().isRequired(), dataSource: stringType() }).shape({
      itemId: stringType(),
      dataSources: stringType(),
      identifiers: shapeType({
        canonicalUrl: stringType(),
        rentalCategory: stringType(),
        rentalSubCategory: stringType()
      })
    })
  }
);

export default DeliveryProvider;
